export const CHUNK_SIZE = 1024 * 1024 * 5;
export const MAX_ATTEMPTS_PER_CHUNK = 5;
